import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import "./NotFound.css";

function NotFound() {
  return (
    <motion.main
      className="page notfound"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4 }}
    >
      <div className="container notfound__inner">
        <span className="notfound__code">404</span>
        <h1>
          This page is <em>off the shipping route.</em>
        </h1>
        <p>
          The link you followed doesn't lead anywhere on our site. Let's get
          you back on course.
        </p>
        <Link to="/" className="btn btn-primary">
          <FiArrowLeft /> Back to home
        </Link>
      </div>
    </motion.main>
  );
}

export default NotFound;
